import React, { useState } from "react";
import styles from "./styles.module.css";
import { AnimalMap } from "../animalMap/index";
import {  
    ProductOFmainTable, 
    TotaltypesOfproducts, 
  } from "../../../components/tables/index";
  import ProductPlantsChart from "../../tables/animaltables/productionTables/table1";
  import AnimalProductionChart2 from "../../tables/animaltables/productionTables/tabble2";
  import MilkProdChart from "../../tables/animaltables/productionTables/milk";
  import WoolProdChart from "../../tables/animaltables/productionTables/wool";
  import EggProdChart from "../../tables/animaltables/productionTables/egg";
  import MeatProdChart from "../../tables/animaltables/productionTables/meat";
import styled from "styled-components";
import { Button } from "antd";

const Container = styled.div`
  position: relative;
  height: 100%;
 
`;

const Content = styled.div`
  // flex: 1;
  padding: 20px;
`;

const ButtonContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 999;
`;

export const Animal = () => {
  const [collapsed, setCollapsed] = useState(false);

  
  const [activeTab, setActiveTab] = useState<"map" | "statistics">("map");

 
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };


  const handleTabChange = (tab: "map" | "statistics") => {
    setActiveTab(tab);
  };

  return (
    <Container>
      {/* <Sidebar collapsed={collapsed} /> */}
      <Content>
        <ButtonContainer>
          <Button
            type={activeTab === "map" ? "primary" : "default"}
            onClick={() => handleTabChange("map")}
          >
            Карта
          </Button>
          <Button
            type={activeTab === "statistics" ? "primary" : "default"}
            onClick={() => handleTabChange("statistics")}
          >
            Статистика и аналитика
          </Button>
        </ButtonContainer>

        {activeTab === "map" ? (
          <div className={styles.mapBackground}>
            <AnimalMap latitude={41.5089324} longitude={74.724091} />
            <ProductOFmainTable />
            <TotaltypesOfproducts/>
          </div>
        ) : (
            <div className={styles.tables_animal_production}>
              
          <ProductPlantsChart/>
          <AnimalProductionChart2/>
          <MilkProdChart/>
          <WoolProdChart/>
          <EggProdChart/>
          <MeatProdChart/>
        
         </div>
        )}
      </Content>
    </Container>
  );
};
